@if (keyValuePairs()?.length > 0) {
<div class="kvp-wrapper">
    <dl class="kvp-list">
        @for (pair of keyValuePairs(); track $index;) {
        <div class="kvp-row">
            <div class="flex">
                <dt class="kvp-key">{{ pair.key }}</dt>
                @if(pair.tooltip != null && pair.tooltip !== "") {
                <button
                    class="info-icon"
                    type="button"
                    aria-label="Vis mer informasjon om {{ pair.key }}"
                    [attr.aria-expanded]="showTooltip()[$index]"
                    (click)="onTooltipToggle($index)"
                    (keydown)="onTooltipKeydown($event, $index)"
                    (clickOutside)="onTooltipClose($index)"
                >
                    <ev_tooltip
                        [title]="pair.key"
                        [visible]="showTooltip()[$index]"
                        [bottom]="25"
                        [left]="-30"
                        [arrowAlignLeft]="36"
                        [arrowBottomAlign]="-8"
                        [arrow]="'bottom'"
                        >{{ pair.tooltip }}
                    </ev_tooltip>
                </button>
                }
            </div>
            <dd class="kvp-value">
                <div class="original-value">{{ pair.value }}</div>
                @if(pair.isOverridden){ <span class="overridden-arrow"></span>
                <div class="new-value">{{ pair.newValue }}</div>
                }
            </dd>
        </div>
        }
    </dl>
</div>
}
